"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M7.88 1s-4.9 6.28-4.9 8.9c.01 2.82 2.34 5.1 4.99 5.1 2.65-.01 5.03-2.3 5.03-5.13C12.99 7.17 7.88 1 7.88 1z"];
//# sourceMappingURL=tint.js.map